import React, {useState} from 'react';
import Header from '../../layout/header/header';
import Sidebar from '../../layout/sidebar/sidebar';
import BookCenter from '../../layout/center/booking';
import "../../assets/styles/style.css";
function Table(props) {
  const [searchPlace, setSearchPlace] = useState('');

  const handleSearch = (term) => {
    setSearchPlace(term);
  };
    return (
        <div className='container' >
        <Header placeholder={'Search place by name...'} isHomePage={false} onSearch={handleSearch}/>
        <Sidebar/>
        <BookCenter searchPlace={searchPlace}/>
      </div>
    );
}

export default Table;